import React, { useState, useEffect } from 'react';
import '../../style/Header.scss';
// bootstrap
import { Image, Navbar, Nav, NavDropdown, Form, Button } from 'react-bootstrap';
// Redux
import { connect } from 'react-redux';
// React-Router
import { Link } from 'react-router-dom';
// component
import DropdownItem from '../DropdownItem';
// action
import * as actionType from '../../store/action';

function Header({ lang, lang_update }) {
  // images
  const logo =
    'https://firebasestorage.googleapis.com/v0/b/kunga-58b60.appspot.com/o/images%2Flogo.png?alt=media&token=4e101b01-3d27-4d9a-b6ad-18d34988cf36';
  // local states
  const [chinese, setChinese] = useState('notActive');
  const [tibetan, setTibetan] = useState('notActive');
  const [english, setEnglish] = useState('notActive');

  useEffect(() => {
    if (lang === 'CH') {
      setChinese('active');
      setTibetan('notActive');
      setEnglish('notActive');
    } else if (lang === 'TIB') {
      setChinese('notActive');
      setTibetan('active');
      setEnglish('notActive');
    } else if (lang === 'ENG') {
      setChinese('notActive');
      setTibetan('notActive');
      setEnglish('active');
    }
  }, [lang]);
  // chinese Dropdown
  const kagyuChineseDropdownList = [
    { title: '傳承', link: '/kyagu' },
    { title: '達瑪旺秋', link: '/kyagu1' },
    { title: '帝師瑞巴', link: '/kyagu2' },
    { title: '瑞巴卡波', link: '/kyagu3' },
    { title: '慮美多傑', link: '/kyagu4' },
    { title: '蔣秋修奴', link: '/kyagu5' },
    { title: '羅焯嘉參', link: '/' },
    { title: '瑞巴尊珠巴', link: '/' },
    { title: '瑞巴扎巴蔣參', link: '/' },
    { title: '索南桑波', link: '/' },
    { title: '空行母德炯桑莫', link: '/' },
    { title: '巴威多傑', link: '/' },
    { title: '噶舉扎西', link: '/' },
    { title: '德薩王噶', link: '/' },
    { title: '蔣揚洛卓仁謙', link: '/lodue' },
  ];

  const teachingChineseDropdownList = [
    {
      title: '四加行',
      link: '/',
    },

    {
      title: '大手印',
      link: '/',
    },
    {
      title: '身',
      link: '/howToRun',
    },
    {
      title: '氣',
      link: '/teaching1',
    },
    {
      title: '明點',
      link: '/teaching2',
    },
    {
      title: '明點',
      link: '/teaching3',
    },
    {
      title: '拙火',
      link: '/teaching4',
    },
    {
      title: '幻身',
      link: '/',
    },
    {
      title: '光明',
      link: '/',
    },
    {
      title: '夢修',
      link: '/dream',
    },
    {
      title: '中陰',
      link: '/',
    },
    {
      title: '破瓦',
      link: '/',
    },
    {
      title: '幻輪',
      link: '/',
    },
    {
      title: '施身法',
      link: '/',
    },
  ];

  const charityChineseDropdownList = [
    { title: '幼兒園', link: '/school1' },
    { title: '職業學校', link: '/' },
  ];

  const artsChineseDropdownList = [
    { title: '古代藏文', link: '/' },
    { title: '近代藏文', link: '/' },
    { title: '作品', link: '/calligraphy' },
    { title: '作品展出', link: '/exhibition' },
    { title: '教學影片', link: '/' },
  ];

  const medicineChineseDropdownList = [
    { title: '青美藏醫診所', link: '/chimeClinic' },
    { title: '三味湯', link: '/' },
    { title: '幻輪油', link: '/' },
    { title: '藥浴', link: '/' },
  ];


  return (
    <>
      <div className='header bg-primary d-flex justify-content-center'>
        <Link to='/'>
          <div className='d-flex align-items-end p-4 '>
            <h3 className='text-secondary tibetan_OuChan2  d-none d-lg-block '>
              ཚང་གསར་ཀུན་དགའ་རིན་པོ་ཆེ།
            </h3>
            <Image
              src={logo}
              roundedCircle
              fluid
              className='logo d-none d-lg-block'
            />
            <h5 className='text-secondary chinese  d-none d-lg-block '>
              八融般若文化教育協會
            </h5>
          </div>
        </Link>
      </div>

      {/* Chinese  main navbar */}
      {lang === 'CH' ?
        (<Navbar collapseOnSelect expand='lg' variant='dark' className='mainNav'>
          {/* navbar-logo */}
          <Navbar.Brand href='/' className='d-lg-none'>
            <div className='d-flex align-items-center'>
              <Image src={logo} fluid className='logo' />
              <h5 className='text-secondary'>ཚང་གསར་ཀུན་དགའ་རིན་པོ་ཆེ།</h5>
            </div>
          </Navbar.Brand>
          <Navbar.Toggle
            aria-controls='responsive-navbar-nav'
            className='border-secondary'
          />
          <Navbar.Collapse id='responsive-navbar-nav'>
            <Nav className='m-auto'>
              {/*navigation link HOME*/}
              <Nav.Link className='singleNavLink' >
                <Link className='navLink' to='/'>
                  首頁
              </Link>
              </Nav.Link>

              {/*navigation link uptodate*/}
              <Nav.Link className='singleNavLink'>
                <Link className='navLink' to='/schedule'>
                  最新
                </Link>
              </Nav.Link>

              {/*navigation link About */}
              <Nav.Link className='singleNavLink'>
                <Link className='navLink' to='/about'>
                  仁波切
                </Link>
              </Nav.Link>

              {/*navigation link Kyagu DropDown*/}
              <NavDropdown
                title='傳承'
                id='collasible-nav-dropdown'
              >
                {/* dropdown 0 */}
                {kagyuChineseDropdownList.map((dropdown) => (
                  <p key={dropdown.title}>
                    <DropdownItem title={dropdown.title} link={dropdown.link} />
                  </p>
                ))}
              </NavDropdown>

              {/*navigation link Teaching  Dropdown*/}
              <NavDropdown
                title='課程'
                id='collasible-nav-dropdown'
              >
                {/* inner dropdown list */}
                {teachingChineseDropdownList.map((dropdown) => (
                  <p key={dropdown.title}>
                    <DropdownItem title={dropdown.title} link={dropdown.link} />
                  </p>
                ))}
              </NavDropdown>

              {/*navigation link */}
              <Nav.Link className='singleNavLink'>
                <Link className='navLink' to='/teachingTimeLine'>
                  法語
                </Link>
              </Nav.Link>
              {/*Dropdown Medicine link */}

              <NavDropdown
                title='醫學'
                id='collasible-nav-dropdown'
              >
                {medicineChineseDropdownList.map((dropdown) => (
                  <p key={dropdown.title} >
                    <DropdownItem title={dropdown.title} link={dropdown.link} />
                  </p>
                ))}
              </NavDropdown>

              {/*Dropdown Arts link */}

              <NavDropdown
                title='藝術'
                id='collasible-nav-dropdown'
              >
                {artsChineseDropdownList.map((dropdown) => (
                  <p key={dropdown.title}>
                    <DropdownItem title={dropdown.title} link={dropdown.link} />
                  </p>
                ))}
              </NavDropdown>
              {/* charity navigation Dropdown */}

              <NavDropdown
                title='公益'
                id='collasible-nav-dropdown'
              >
                {charityChineseDropdownList.map((dropdown) => (
                  <p key={dropdown.title}>
                    <DropdownItem title={dropdown.title} link={dropdown.link} />
                  </p>
                ))}
              </NavDropdown>
              {/*navigation link */}
              <Nav.Link className='singleNavLink' href='#'>
                下載
              </Nav.Link>
              {/*navigation link */}
              <Nav.Link className='singleNavLink'>
                <Link className='navLink' to='/gallery'>
                  活動照片
                </Link>
              </Nav.Link>
              {/*navigation link */}
              <Nav.Link className='singleNavLink'>
                <Link className='navLink' to='/'>
                  影音頻道
                </Link>
              </Nav.Link>
              {/*navigation link */}
              <Nav.Link className='singleNavLink'>
                <Link to='/test' className='navLink'>
                  連結
                </Link>
              </Nav.Link>
              {/*  Language Switch Buttons */}
              <Form inline className='logInBtn m-auto'>
                <Button
                  className={`mr-1 ${chinese}`}
                  onClick={() => {
                    lang_update('CH');
                  }}
                >
                  中文
              </Button>
                <Button
                  className={`mr-1 ${tibetan}`}
                  onClick={() => {
                    lang_update('TIB');
                  }}
                >
                  བོད་ཡིག།
              </Button>
                <Button
                  className={`${english}`}
                  onClick={() => {
                    lang_update('ENG');
                  }}
                >
                  ENG
              </Button>
              </Form>
            </Nav>
          </Navbar.Collapse>
        </Navbar>) : (
          // Tibetan main navbar
          <Navbar collapseOnSelect expand='lg' variant='dark' className='mainNav'>
            {/* navbar-logo */}
            <Navbar.Brand href='/' className='d-lg-none'>
              <div className='d-flex align-items-center'>
                <Image src={logo} fluid className='logo' />
                <h5 className='text-secondary'>ཚང་གསར་ཀུན་དགའ་རིན་པོ་ཆེ།</h5>
              </div>
            </Navbar.Brand>
            <Navbar.Toggle
              aria-controls='responsive-navbar-nav'
              className='border-secondary'
            />
            <Navbar.Collapse id='responsive-navbar-nav'>
              <Nav className='m-auto'>

                {/*navigation link HOME*/}
                <Nav.Link className='singleNavLink'>
                  <Link className='navLink' to='/'>
                    མདུན་ངོས།
                  </Link>
                </Nav.Link>

                {/*navigation link HOME*/}
                <Nav.Link className='singleNavLink'>
                  <Link className='navLink' to='/about'>
                    ཚང་གསར།
                  </Link>
                </Nav.Link>

                {/*navigation link HOME*/}
                <Nav.Link className='singleNavLink'>
                  <Link className='navLink' to='/kyagu'>
                    བཀའ་བརྒྱུད།
                  </Link>
                </Nav.Link>

                {/*navigation link HOME*/}
                <Nav.Link className='singleNavLink'>
                  <Link className='navLink' to='/'>
                    སློབ་ཁྲིད།
                  </Link>
                </Nav.Link>

                {/*navigation link HOME*/}
                <Nav.Link className='singleNavLink'>
                  <Link className='navLink' to='/arts'>
                    སྒྱུ་རྩལ།
                  </Link>
                </Nav.Link>

                {/*navigation link HOME*/}
                <Nav.Link className='singleNavLink'>
                  <Link className='navLink' to='/mentse'>
                    སྨན་རྩིས།
                  </Link>
                </Nav.Link>

                {/*navigation link HOME*/}
                <Nav.Link className='singleNavLink'>
                  <Link className='navLink' to='/charity'>
                    དགེ་ལས།
                  </Link>
                </Nav.Link>

                {/*navigation link HOME*/}
                <Nav.Link className='singleNavLink'>
                  <Link className='navLink' to='/monastery'>
                    དགོན་གནས།
                  </Link>
                </Nav.Link>

                {/*navigation link HOME*/}
                <Nav.Link className='singleNavLink'>
                  <Link className='navLink' to='/people'>
                    མི་སྣ།
                  </Link>
                </Nav.Link>

                {/*navigation link HOME*/}
                <Nav.Link className='singleNavLink'>
                  <Link className='navLink' to='/'>
                    ཐོན་དངོས།
                  </Link>
                </Nav.Link>

                {/*navigation link HOME*/}
                <Nav.Link className='singleNavLink'>
                  <Link className='navLink' to='/'>
                    བརྙན་པར།
                  </Link>
                </Nav.Link>

                {/*navigation link HOME*/}
                <Nav.Link className='singleNavLink'>
                  <Link className='navLink' to='/'>
                    ཕབ་ལེན།
                  </Link>
                </Nav.Link>

                {/*navigation link HOME*/}
                <Nav.Link className='singleNavLink'>
                  <Link className='navLink' to='/'>
                    འབྲེལ་མཐུད།
                  </Link>
                </Nav.Link>

                {/* navigation link Kyagu DropDown */}
                {/* <NavDropdown
                  title='བཀའ་བརྒྱུད།'
                  id='collasible-nav-dropdown'
                >
                  {kagyuChineseDropdownList.map((dropdown) => (
                    <p key={dropdown.title}>
                      <DropdownItem title={dropdown.title} link={dropdown.link} />
                    </p>
                  ))}
                </NavDropdown> */}

                {/*  Language Switch Buttons */}
                <Form inline className='logInBtn m-auto'>
                  <Button
                    className={`mr-1 ${chinese}`}
                    onClick={() => {
                      lang_update('CH');
                    }}
                  >
                    中文
            </Button>
                  <Button
                    className={`mr-1 ${tibetan}`}
                    onClick={() => {
                      lang_update('TIB');
                    }}
                  >
                    བོད་ཡིག།
            </Button>
                  <Button
                    className={`${english}`}
                    onClick={() => {
                      lang_update('ENG');
                    }}
                  >
                    ENG
            </Button>
                </Form>
              </Nav>
            </Navbar.Collapse>
          </Navbar>)
      }
    </>
  );
}

const mapStateToProps = (state) => {
  return {
    lang: state.lang.lang,
  };
};

const mapActionToProps = (dispatch) => {
  return {
    lang_update: (language) =>
      dispatch({ type: actionType.LANGUAGE_UPDATE, lang: language }),
  };
};
export default connect(mapStateToProps, mapActionToProps)(Header);
